module.exports = __webpack_public_path__ + "img/img-3.ec1f334c.webp";